import { linkedIn, github, stackOverflow, twitter, facebook } from './assets'

export default {
  linkedIn: {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/in/przemyslaw-zalewski-ciunkos',
    icon: linkedIn
  },
  gitHub: {
    name: 'GitHub',
    url: 'https://github.com/Ciunkos',
    icon: github
  },
  stackOverflow: {
    name: 'StackOverflow',
    url: 'https://stackoverflow.com/users/1384679/przemys%C5%82aw-zalewski',
    icon: stackOverflow
  },
  twitter: {
    name: 'Twitter',
    url: 'https://twitter.com/Ciunkos',
    icon: twitter
  },
  facebook: {
    name: 'Facebook',
    url: 'https://www.facebook.com/ciunkos',
    icon: facebook
  }
}
